import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-json-reader-modal',
  templateUrl: './json-reader-modal.component.html',
})
export class JsonReaderModalComponent {
  @Input() json?: string

  constructor(public activeModal: NgbActiveModal) {}
}
